import { render, staticRenderFns } from "./bonus-schemes.vue?vue&type=template&id=4b5ec335"
import script from "./bonus-schemes.vue?vue&type=script&lang=js"
export * from "./bonus-schemes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports